export default __webpack_public_path__ + "static/media/recent.a11d2f14.svg";